import script from "./uploadImg.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadImg.vue?vue&type=script&setup=true&lang=js"

import "./uploadImg.vue?vue&type=style&index=0&id=d2c766fc&lang=css"

const __exports__ = script;

export default __exports__